module.exports = __webpack_public_path__ + "static/media/harmac.56593897.jpg";